import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { LineUpPage } from './line-up';
import { Ionic2RatingModule } from 'ionic2-rating';

@NgModule({
  declarations: [
    LineUpPage,
  ],
  imports: [
    IonicPageModule.forChild(LineUpPage),
    Ionic2RatingModule
  ],
  exports: [
    LineUpPage
  ]
})
export class LineUpPageModule {}



// WEBPACK FOOTER //
// ./src/pages/line-up/line-up.module.ts